/* import __COLOCATED_TEMPLATE__ from './courses-calendar-filter.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { modifier } from 'ember-modifier';
import { TrackedAsyncData } from 'ember-async-data';
import { findBy, sortBy } from 'ilios-common/utils/array-helpers';
import currentAcademicYear from 'ilios-common/utils/current-academic-year';
let DashboardCoursesCalendarFilterComponent = (_class = class DashboardCoursesCalendarFilterComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "dataLoader", _descriptor, this);
    _initializerDefineProperty(this, "iliosConfig", _descriptor2, this);
    _initializerDefineProperty(this, "_expandedYears", _descriptor3, this);
    _initializerDefineProperty(this, "yearsInView", _descriptor4, this);
    _initializerDefineProperty(this, "titlesInView", _descriptor5, this);
    _defineProperty(this, "scrollToDefaultExpandedYear", modifier((element, [year]) => {
      if (year === this.defaultExpandedYear) {
        const {
          offsetTop
        } = element;
        element.parentElement.scrollTo({
          top: offsetTop,
          behavior: 'instant'
        });
      }
    }));
  }
  get academicYearCrossesCalendarYearBoundariesData() {
    return new TrackedAsyncData(this.iliosConfig.itemFromConfig('academicYearCrossesCalendarYearBoundaries'));
  }
  get academicYearCrossesCalendarYearBoundaries() {
    return this.academicYearCrossesCalendarYearBoundariesData.isResolved ? this.academicYearCrossesCalendarYearBoundariesData.value : false;
  }
  get schoolCalendarData() {
    return new TrackedAsyncData(this.dataLoader.loadSchoolForCalendar(this.args.school.id));
  }
  get schoolCalendar() {
    return this.schoolCalendarData.isResolved ? this.schoolCalendarData.value : null;
  }
  get coursesRelationshipData() {
    return new TrackedAsyncData(this.args.school.courses);
  }
  get coursesRelationship() {
    if (!this.args.school) {
      return null;
    }
    return this.coursesRelationshipData.isResolved ? this.coursesRelationshipData.value : null;
  }
  get expandedYearWithoutTitleView() {
    const yearsWithNoTitle = this.yearsInView.filter(year => !this.titlesInView.includes(year));
    const expandedYearsWithNoTitle = yearsWithNoTitle.filter(year => this.expandedYears.includes(year));
    if (expandedYearsWithNoTitle.length) {
      return expandedYearsWithNoTitle[0];
    }
    return null;
  }
  get courses() {
    return this.coursesRelationship ? this.coursesRelationship : [];
  }
  get courseYears() {
    const courseYears = this.courses.reduce((acc, course) => {
      let year = acc.find(({
        year
      }) => year === course.year);
      const label = this.academicYearCrossesCalendarYearBoundaries ? `${course.year} - ${course.year + 1}` : course.year.toString();
      if (!year) {
        year = {
          label,
          year: course.year,
          courses: []
        };
        acc.push(year);
      }
      year.courses.push(course);
      return acc;
    }, []);
    return sortBy(courseYears, 'year').reverse();
  }
  get defaultExpandedYear() {
    if (this.courseYears.length) {
      const academicYear = currentAcademicYear();
      const coursesThisYear = findBy(this.courseYears, 'year', academicYear);
      return coursesThisYear ? academicYear : this.courseYears[0].year;
    }
    return false;
  }
  get expandedYears() {
    if (this._expandedYears !== undefined) {
      return this._expandedYears;
    }
    return this.defaultExpandedYear ? [this.defaultExpandedYear] : [];
  }
  toggleYear(year) {
    if (this.expandedYears.includes(year)) {
      this._expandedYears = this.expandedYears.filter(theYear => theYear !== year);
    } else {
      this._expandedYears = [...this.expandedYears, year];
    }
  }
  addYearInView(year) {
    if (!this.yearsInView.includes(year)) {
      this.yearsInView = [...this.yearsInView, year];
    }
  }
  removeYearInView(year) {
    this.yearsInView = this.yearsInView.filter(theYear => theYear !== year);
  }
  addTitleInView(title) {
    if (!this.titlesInView.includes(title)) {
      this.titlesInView = [...this.titlesInView, title];
    }
  }
  removeTitleInView(title) {
    this.titlesInView = this.titlesInView.filter(theTitle => theTitle !== title);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dataLoader", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_expandedYears", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "yearsInView", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "titlesInView", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "academicYearCrossesCalendarYearBoundariesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "academicYearCrossesCalendarYearBoundariesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "schoolCalendarData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "schoolCalendarData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "coursesRelationshipData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "coursesRelationshipData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleYear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleYear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addYearInView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addYearInView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeYearInView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeYearInView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addTitleInView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addTitleInView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeTitleInView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeTitleInView"), _class.prototype), _class);
export { DashboardCoursesCalendarFilterComponent as default };